module.exports = __webpack_public_path__ + "static/img/A68.e06c02d2.jpg";